import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom';
import interceptor from '../../utils/HttpInterceptor';
import { agregarTokenSocio, agregarIdFlujoSocio, refresTokenAction } from './MainAction';

class SeguridadMain extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.cargaInicial = this.cargaInicial.bind(this);
    this.idFlujoInicial = this.idFlujoInicial.bind(this);
  }

  cargaInicial = () => {
    const { location, agregarToken, refresToken } = this.props;
    const token = new URLSearchParams(location.search).get("token");
    const idFlujoUrl = new URLSearchParams(location.search).get("idFlujo");
    const idFlujo = idFlujoUrl ? Number(idFlujoUrl) : 1;

    const trace = JSON.parse(sessionStorage.getItem('trace'));
    trace.trace.push({ paso: "SeguridadMauin" })
    sessionStorage.setItem('trace', JSON.stringify(trace));

    if (token !== null &&
      token !== undefined &&
      token !== '') {
      interceptor(token, idFlujo);
      agregarToken(token);
      refresToken(false)
      return true;
    }
    return false;
  }

  idFlujoInicial = () => {
    const { location, agregarIdFlujo } = this.props;
    const idFlujoUrl = new URLSearchParams(location.search).get("idFlujo");
    const idFlujo = idFlujoUrl ? Number(idFlujoUrl) : 1;
    agregarIdFlujo(idFlujo);
    return idFlujo;

  }

  render() {
    const respConsumirServicios = this.cargaInicial();
    const respFlujo = this.idFlujoInicial();
    if (respConsumirServicios && respFlujo === 1) {
      return (
        <Redirect to="/Simulador" />
      );
    }

    return (
      <Redirect to="/Page404" />
    );
  }
}

const mapStateToProps = state => {
  return {
    datosPersona: state.datosPersona.datosBasicosPersona
  }
}

const mapDispatchToProps = dispatch => {
  return {
    agregarToken: (token) => dispatch(agregarTokenSocio(token)),
    agregarIdFlujo: (idFlujo) => dispatch(agregarIdFlujoSocio(idFlujo)),
    refresToken: (tokenLiveType) => dispatch(refresTokenAction(tokenLiveType))

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeguridadMain);